export default "__VITE_ASSET__de390e8d__"